import React from "react";
import Consultmaster from "./consultMaster";
import { withHoverDrawer } from "../../HOCs";

class ConsultParent extends React.Component {
  render() {
    return <Consultmaster />;
  }
}

export default withHoverDrawer(ConsultParent);
